import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { FunctionComponent, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FileAcceptType, UploadType } from '../../../../../hooks';
import { VideoBlockDataItem } from '../../../../../models';
import { CloseWrapper, MediaBlockUpload, MediaBlockUploadPreview } from '../../helpers';

export const VideoNodeView: FunctionComponent<NodeViewProps> = ({
  editor,
  node,
  getPos,
  updateAttributes,
}) => {
  const { t } = useTranslation();

  const items = node.attrs.items as VideoBlockDataItem[];

  const pastedFiles = node.attrs.pastedFiles as File[] | undefined;

  const [loading, setLoading] = useState<boolean>(false);

  const content = useMemo(() => {
    const { video = null } = { ...items[0] };

    if (video) {
      return (
        <MediaBlockUploadPreview iconId={'video'} label={t('richTextEditor.video-placeholder')} />
      );
    }

    return (
      <MediaBlockUpload
        items={items}
        setItems={(items) => updateAttributes({ items })}
        pastedFiles={pastedFiles}
        loading={loading}
        setLoading={setLoading}
        fileAcceptType={FileAcceptType.VIDEO}
        uploadType={UploadType.VIDEO}
      />
    );
  }, [items, loading, pastedFiles, t, updateAttributes]);

  return (
    <NodeViewWrapper as={'div'}>
      <CloseWrapper
        editor={editor}
        node={node}
        getPos={getPos}
        loading={Boolean(loading || (pastedFiles?.length && !items.length))}
      >
        {content}
      </CloseWrapper>
    </NodeViewWrapper>
  );
};
